/**
 * Represents a list of commenting IDs.
 * @typedef {Object} CommentingIdList
 * @property {string} FEEDBACK_TO_ARTIST_LABEL - ID for providing feedback to artist/label.
 * @property {string} REQUEST_ADDITIONAL_PROMO - ID for requesting additional promo materials.
 * @property {string} REQUEST_ADDITIONAL_MUSIC - ID for requesting additional music.
 * @property {string} REQUEST_SCHEDULE_INTERVIEW - ID for requesting/scheduling an interview.
 * @property {string} REQUEST_FILE_FORMAT - ID for requesting a specific file format (e.g. .WAV or .MP3).
 * @property {string} REQUEST_SONG_VERSION - ID for requesting a song version.
 * @property {string} REQUEST_ARTIST_LINER - ID for requesting an artist liner.
 * @property {string} OTHER - ID for other requests or actions.
 */

export const MUSIC_INTERACTION_ACTIONS = Object.freeze({
  FEEDBACK_TO_ARTIST_LABEL: 'commenting-feedback-to-artist-label',
  REQUEST_ADDITIONAL_PROMO: 'commenting-request-additional-promo',
  REQUEST_ADDITIONAL_MUSIC: 'commenting-request-additional-music',
  REQUEST_SCHEDULE_INTERVIEW: 'commenting-request-schedule-interview',
  REQUEST_FILE_FORMAT: 'commenting-request-file-format',
  REQUEST_SONG_VERSION: 'commenting-request-song-version',
  REQUEST_ARTIST_LINER: 'commenting-request-artist-liner',
  OTHER: 'commenting-other'
})

export const SIGN_UP_WORK_IN_OPTIONS = [
  { key: 'RADIO', value: 'radio', label: 'me-work-in-radio' },
  {
    key: 'PRESS_PUBLICITY_MEDIA',
    value: 'press-publicity-media',
    label: 'me-work-in-press-publicity-media'
  },
  { key: 'OTHER', value: 'other', label: 'me-work-in-other' }
]

export const SIGN_UP_EMAIL_STATUS = Object.freeze({
  EMAIL_AVAILABLE: 'available',
  EMAIL_TAKEN: 'taken'
})

export const REQUEST_MORE_MUSIC_URL = 'https://survey.zohopublic.com/zs/kmCsLO'

export const REQUEST_NEW_LIST_URL = 'https://survey.zohopublic.com/zs/7ACCRj'
